import type React from 'react';

import Box from '@mui/material/Box';

import type { PageActionsPosition } from '../PageActions';

import {
  MOBILE_FAB_INLINE_CLEARANCE,
  PAGE_WITH_MOBILE_FAB,
} from '../../../components/PageActionsButton/mobileFab';

export interface PageFooterProps {
  /**
   * Position of the actions.
   * @default start
   */
  position?: PageActionsPosition;
  children: React.ReactNode;
  className?: string;
}

const positionMap: Record<PageActionsPosition, string> = {
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
};

const PageFooter = ({ children, position = 'start' }: PageFooterProps) => (
  <Box
    justifyContent={positionMap[position]}
    sx={{
      borderColor: 'divider',
      // The phone's floating "+" sits in this band's bottom-right corner: in
      // the page that holds it, the footer's own controls (a pager's Next
      // arrow) must end left of it, or a tap there opens the "+" instead.
      [`${PAGE_WITH_MOBILE_FAB} > &`]: {
        paddingRight: MOBILE_FAB_INLINE_CLEARANCE,
      },
    }}
    alignItems="center"
    display="flex"
    flexShrink={0}
    py={1.5}
  >
    {children}
  </Box>
);

export default PageFooter;
